/* =============================================================================
   ENGKANTO CUSTOM JS
   Shared Alpine.js component functions for custom Engkanto blocks.
   Only functions with NO Liquid variable dependencies live here.
   Scripts that embed product JSON, section IDs, or theme settings must
   remain as inline <script> tags in their respective snippet files.
   ============================================================================= */


/* -----------------------------------------------------------------------------
   snippets/quantity-variant-picker.liquid
   Initialises the Alpine store and registers the picker component.
   ----------------------------------------------------------------------------- */

(function () {
  function initQuantityPickerStore() {
    if (!Alpine.store('quantityPicker')) {
      Alpine.store('quantityPicker', { quantities: {}, showValidation: false });
    }
  }

  if (window.Alpine) {
    initQuantityPickerStore();
  } else {
    document.addEventListener('alpine:init', initQuantityPickerStore);
  }
})();

window.quantityVariantPicker = window.quantityVariantPicker || function (product) {
  return {
    product,
    init() {
      const qs = {};
      product.variants.forEach(function (v) { qs[v.id] = 0; });
      this.$store.quantityPicker.quantities = qs;
    },
    increment(variantId) {
      this.$store.quantityPicker.quantities[variantId]++;
      this.$store.quantityPicker.quantities = Object.assign({}, this.$store.quantityPicker.quantities);
      this.$store.quantityPicker.showValidation = false;
    },
    decrement(variantId) {
      if (this.$store.quantityPicker.quantities[variantId] > 0) {
        this.$store.quantityPicker.quantities[variantId]--;
        this.$store.quantityPicker.quantities = Object.assign({}, this.$store.quantityPicker.quantities);
      }
    },
  };
};


/* -----------------------------------------------------------------------------
   snippets/quantity-buy-button.liquid
   ----------------------------------------------------------------------------- */

window.quantityBuyButton = window.quantityBuyButton || function () {
  return {
    loading: false,
    errorMessage: null,
    addedToCart: false,
    get hasItems() {
      const quantities = this.$store.quantityPicker && this.$store.quantityPicker.quantities;
      return quantities && Object.values(quantities).some(function (q) { return q > 0; });
    },
    async addToCart() {
      const quantities = (this.$store.quantityPicker && this.$store.quantityPicker.quantities) || {};
      const items = Object.entries(quantities)
        .filter(function ([, qty]) { return qty > 0; })
        .map(function ([id, qty]) { return { id: parseInt(id), quantity: qty }; });

      if (!items.length) {
        this.$store.quantityPicker.showValidation = true;
        return;
      }

      this.loading = true;
      this.errorMessage = null;
      this.addedToCart = false;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: ['cart-items', 'cart-footer', 'cart-item-count'],
            sections_url: window.location.pathname,
          }),
        });

        if (res.ok) {
          const data = await res.json();
          document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: data } }));
          this.addedToCart = true;
          this.$store.quantityPicker.quantities = Object.fromEntries(
            Object.keys(quantities).map(function (id) { return [id, 0]; })
          );
        } else {
          const data = await res.json();
          this.errorMessage = data.description || 'Could not add to cart.';
        }
      } catch (e) {
        this.errorMessage = 'Something went wrong. Please try again.';
      } finally {
        this.loading = false;
      }
    },
  };
};
